import React, {useEffect, useState} from 'react'
import {infoArrive, thisSymbolComesFirst} from '../../helper/HelperFunctions'
import {useLocation} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import OpinionButton from "../OpinionButton/OpinionButton";
import PropTypes from 'prop-types'
import Paper from "@material-ui/core/Paper";
import Loading from "../Loading/Loading";

const useStyles = makeStyles((theme) => ({
    alignCenter: {
        textAlign: 'center',
        boxShadow: '0px -2px 2px 0px #E5E7EB',
        paddingTop: 10
    },
    spreadButtons: {
        marginRight: 40,
    },
    buttonSize: {
        '& button': {
            maxHeight: 20,
            fontSize: 10,
        }
    },
    images: {
        color: '#011238',
        [theme.breakpoints.down(580)]: {
            display: 'flex',
            textAlign: 'center',
            margin: '0px auto',
            maxWidth: '60vw'
        },
        [theme.breakpoints.up(580)]: {
            marginBottom: '30px',
            marginTop: '30px',
            float: 'left',
            maxWidth: '170px',
            margin: '30px 15px',
        },

    },
    imagesBeforeText: {
        color: '#011238',
        [theme.breakpoints.down(580)]: {
            display: 'flex',
            textAlign: 'center',
            margin: '30px auto',
            maxWidth: '60vw',
        },
        [theme.breakpoints.up(580)]: {
            display: 'inherit',
            maxWidth: '170px',
            margin: '30px 15px',
        },
    },
    videos: {
        [theme.breakpoints.down(580)]: {
            maxWidth: '315px',
        },
        [theme.breakpoints.up(580)]: {
            maxWidth: '760px',
            height: '400px',
        },

        marginTop: 30
    },
    containerInfo: {
        backgroundColor: 'white',
        borderTop: 'solid 4px #00c121',
        borderBottom: 'solid 4px #00c121',
        marginBottom: '50px',
        paddingBottom: '30px',
        width: '600px',
        marginLeft: "auto",
        marginRight: "auto",
        padding: theme.spacing(4),
        color: '#011238',
    },
    containerInfoMobile: {
        backgroundColor: 'white',
        padding: theme.spacing(3),
        color: '#011238',
    },
    loadingContainer: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        background: 'white',
        padding: 16,
        [theme.breakpoints.up(480)]: {
            width: 460
        },
        [theme.breakpoints.up(1024)]: {
            marginTop: 64
        },
    },
    titleH3: {
        margin: theme.spacing(2),
        fontFamily: "Lato",
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#011238',
    },
    titleH2: {
        margin: theme.spacing(3),
        fontFamily: "Lato",
        fontSize: '22px',
        color: '#011238',
        fontWeight: 'bold'
    },
    titleH1: {
        margin: theme.spacing(4),
        fontFamily: "Lato",
        fontSize: '24px',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#011238',
    },
    text: {
        display: 'inline',
        color: '#011238',
        clear: 'both',
    },
    textBold: {
        fontFamily: "Lato",
        display: 'inline',
        fontWeight: 'bold',
        color: '#011238',
    },
    jumpSpace: {
        margin: theme.spacing(2),
        display: 'block',
    },
    link: {
        display: 'inline',
        clear: 'both',
    }
}));

const theme = createMuiTheme({
    typography: {
        fontFamily: [
            '"Lato"',
            '"Roboto"',
            'sans-serif'
        ].join(','),
    },
    palette: {
        primary: {
            main: '#28C339'
        },
        secondary: {
            main: '#011238',
        }
    },
});

const InfoBox = ({country, infoData, isMobile}) => {
    const classes = useStyles();
    let location = useLocation()
    let url = location.pathname

    const [infoState, setInfoState] = useState({})
    const [infoArrived, setInfoArrived] = useState(false)
    const [contentWasFilled, setContentWasFilled] = useState(false)
    const [content, setContent] = useState('')
    const [loadContent, setLoadContent] = useState(true)
    const [finalTextInfo, setFinalTextInfo] = useState([{
        link: '',
        alt: '',
        text: '',
        tag: ''
    }])

    useEffect(()=>{
        infoArrive(infoData) && setInfoState(infoData.find(function(info) {
            if(info.urlsubtitle === url && info.country.includes(country)){
                return info
            }
            return null
        }))

        setInfoArrived(true)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [infoData])

    useEffect(()=>{
        infoArrive(infoData) && parsingInfoIntoObject()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [infoArrived, infoState])

    useEffect(()=>{
        infoArrive(content) && callLoopForDivideInfo()
        if(contentWasFilled && content.trim().length===0){
            setLoadContent(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [content])

    const parsingInfoIntoObject = () => {
        if (infoState && infoState.content) {
            setContent(infoState.content)
            setContentWasFilled(true)
        }
    }
    const symbolsToFind = ['[', '#', '![', `\n`, '**']

    const isThisSymbolComesFirst = (symbol) => {
        const otherSymbols = symbolsToFind.filter(symbolToFind => symbolToFind !== symbol)

        return thisSymbolComesFirst(content, otherSymbols, symbol)
    }

    const callLoopForDivideInfo = () => {
        let toObject = {
            link: '',
            alt: '',
            text: '',
            tag: ''
        }

        if(symbolsToFind.some(symbol => content.includes(symbol))){
            let infoCutted
            if(nextSymbolHasPositionZero()){
                let informationToTransfer
                if(whichSymbolComesFirst()==='!'){
                    informationToTransfer = putImgInObject(content)
                    infoCutted = content.substring(content.indexOf(')') + 1)
                    setContent(infoCutted)
                } else if(whichSymbolComesFirst()==='#'){
                    informationToTransfer = putTitleInObject(content)
                    infoCutted = content.substring(content.indexOf(`\n`) + 1)
                    setContent(infoCutted)
                } else if(whichSymbolComesFirst()==='['){
                    informationToTransfer = putLinkInObject(content)
                    infoCutted = content.substring(content.indexOf(')') + 1)
                    setContent(infoCutted)
                } else if(whichSymbolComesFirst()==='*'){
                    informationToTransfer = putTextBold(content)
                    infoCutted = content.substring(content.indexOf('**', 2) + 2)
                    setContent(infoCutted)
                } else if(whichSymbolComesFirst()===`\n`){
                    informationToTransfer = findJumpBar(content)
                    infoCutted = content.substring(1)
                    setContent(infoCutted)
                }
                setFinalTextInfo(finalTextInfo => [...finalTextInfo, informationToTransfer])
            } else {
                if(isThisSymbolComesFirst('![')) {
                    toObject.text = content.substring(0, content.indexOf('!['))
                    infoCutted = content.substring(content.indexOf('!['))
                    setContent(infoCutted)
                } else if(isThisSymbolComesFirst('[')) {
                    toObject.text = content.substring(0, content.indexOf('['))
                    infoCutted = content.substring(content.indexOf('['))
                    setContent(infoCutted)
                } else if(isThisSymbolComesFirst('#')) {
                    toObject.text = content.substring(0, content.indexOf('#'))
                    infoCutted = content.substring(content.indexOf('#'))
                    setContent(infoCutted)
                } else if(isThisSymbolComesFirst('**')) {
                    toObject.text = content.substring(0, content.indexOf('**'))
                    infoCutted = content.substring(content.indexOf('**'))
                    setContent(infoCutted)
                } else if(isThisSymbolComesFirst(`\n`)) {
                    toObject.text = content.substring(0, content.indexOf(`\n`))
                    infoCutted = content.substring(content.indexOf(`\n`))
                    setContent(infoCutted)
                } else {
                    toObject.text = content
                    infoCutted = ''
                    setContent(infoCutted)
                }
                setFinalTextInfo(finalTextInfo => [...finalTextInfo, toObject])
            }
        }
        else {
            if(content.length!==0){
                toObject.text = content
                setFinalTextInfo(finalTextInfo => [...finalTextInfo, toObject])
                setContent('')
                setLoadContent(false)
            }
        }
    }

    const nextSymbolHasPositionZero = () =>{
        if(symbolsToFind.some(symbol => content.indexOf(symbol) === 0)) return true
    }

    const whichSymbolComesFirst = () => {
        return content.charAt(0)
    }

    const getPosition = (string, subString, index) => {
        return string.split(subString, index).join(subString).length;
    }

    const findJumpBar = () => {
        let toObject = {
            link: '',
            alt: '',
            text: '',
            tag: ''
        }
        toObject.text = content.substring(1, 1)

        return toObject
    }

    const putLinkInObject = () => {
        let toObject = {
            link: '',
            alt: '',
            text: '',
            tag: ''
        }
        toObject.link = content.substring(content.indexOf('(') + 1, content.indexOf(')'))
        toObject.text = content.substring(1, content.indexOf(']'))

        return toObject
    }
    const putImgInObject = () => {
        let toObject = {
            link: '',
            alt: '',
            text: '',
            tag: ''
        }
        toObject.alt = content.substring(2, content.indexOf(']'))
        if(content.indexOf('"')>=0){
            toObject.link = content.substring(content.indexOf('(') + 1, content.indexOf('"') - 1)
            toObject.text = content.substring(content.indexOf('"') + 1, getPosition(content, '"', 2))

        } else {
            toObject.link = content.substring(content.indexOf('(') + 1, content.indexOf(')'))
            toObject.text = ''

        }

        return toObject
    }
    const putTitleInObject = () => {
        let toObject = {
            link: '',
            alt: '',
            text: '',
            tag: ''
        }
        if(getPosition(content, '#', 2) && getPosition(content, '#', 3) === 2){
            toObject.tag = 'h3'
            toObject.text = content.substring(4, content.indexOf(`\n`))
        } else  if(getPosition(content, '#', 2) === 1){
            toObject.tag = 'h2'
            toObject.text = content.substring(3, content.indexOf(`\n`))
        } else {
            toObject.tag = 'h1'
            toObject.text = content.substring(2, content.indexOf(`\n`))
        }
        return toObject
    }
    const putTextBold = () => {
        let toObject = {
            link: '',
            alt: '',
            text: '',
            tag: ''
        }
        toObject.tag = 'bold'
        toObject.text = content.substring(2, content.indexOf('**', 2))
        return toObject
    }

    return (
        <ThemeProvider theme={theme}>
            {
                finalTextInfo.length !== 1 && (
                    <>
                        <Paper elevation={isMobile ? 0 : 3 } className={isMobile ? classes.containerInfoMobile : classes.containerInfo }>
                            <div>
                                {
                                    loadContent &&  (
                                        <Loading/>
                                    )
                                }
                                {
                                    finalTextInfo && !loadContent &&
                                    (
                                        finalTextInfo.map(function(row, index) {
                                            if(row.alt.length === 0 && row.link.length !== 0){
                                                if(row.link.includes('http') || row.link.includes('www') || row.link.includes('.com') ){
                                                    return (
                                                        <Typography variant="body1" className={classes.link} key={index}>
                                                            <a href={row.link} target="_blank" rel="noopener noreferrer">{row.text}</a>
                                                        </Typography>
                                                    )
                                                } else {
                                                    return (
                                                        <Typography variant="body1" className={classes.link} key={index}>
                                                            <a href={row.link}>{row.text}</a>
                                                        </Typography>
                                                    )
                                                }
                                            } else if(row.alt.length !== 0 && row.link.length !== 0){
                                                if(finalTextInfo[index+1]
                                                    && ((finalTextInfo[index+1].alt.length !== 0)
                                                        || (finalTextInfo[index+2] && finalTextInfo[index+2].alt.length !== 0 && finalTextInfo[index+1].text.trim().length === 0 )
                                                        || (finalTextInfo[index+3] && finalTextInfo[index+3].alt.length !== 0 && finalTextInfo[index+2].text.trim().length === 0 && finalTextInfo[index+1].text.trim().length === 0 )
                                                        || (finalTextInfo[index+4] && finalTextInfo[index+4].alt.length !== 0 && finalTextInfo[index+3].text.trim().length === 0 && finalTextInfo[index+2].text.trim().length === 0 && finalTextInfo[index+1].text.trim().length === 0 )
                                                        || (finalTextInfo[index+5] && finalTextInfo[index+5].alt.length !== 0 && finalTextInfo[index+4].text.trim().length === 0 && finalTextInfo[index+3].text.trim().length === 0 && finalTextInfo[index+2].text.trim().length === 0 && finalTextInfo[index+1].text.trim().length === 0)
                                                        || (finalTextInfo[index+6] && finalTextInfo[index+6].alt.length !== 0 && finalTextInfo[index+5].text.trim().length === 0 && finalTextInfo[index+4].text.trim().length === 0 && finalTextInfo[index+3].text.trim().length === 0 && finalTextInfo[index+2].text.trim().length === 0 && finalTextInfo[index+1].text.trim().length === 0)))
                                                {
                                                    if(row.text.length !== 0){
                                                        return (
                                                            <a href={row.text} target="_blank" rel="noopener noreferrer">
                                                                <img src={`${row.link}`}
                                                                     alt={row.alt}
                                                                     width="100%"
                                                                     className={classes.images}
                                                                />
                                                            </a>
                                                        )
                                                    } else {
                                                        return (
                                                            <img src={`${row.link}`}
                                                                 alt={row.alt}
                                                                 width="100%"
                                                                 className={classes.images}
                                                            />
                                                        )
                                                    }
                                                } else {
                                                    if(row.text.length !== 0){
                                                        return (
                                                            <a href={row.text} target="_blank" rel="noopener noreferrer">
                                                                <img src={`${row.link}`}
                                                                     alt={row.alt}
                                                                     width="100%"
                                                                     className={classes.imagesBeforeText}
                                                                />
                                                            </a>
                                                        )
                                                    } else {
                                                        return (
                                                            <img src={`${row.link}`}
                                                                 alt={row.alt}
                                                                 className={classes.imagesBeforeText}
                                                            />
                                                        )
                                                    }
                                                }


                                            } else if(row.tag === 'h1') {
                                                return <Typography variant="body1" className={classes.titleH1} key={index}>
                                                    {row.text}
                                                </Typography>
                                            } else if(row.tag === 'h2') {
                                                return <Typography variant="body1" className={classes.titleH2} key={index}>
                                                    {row.text}
                                                </Typography>
                                            } else if(row.tag === 'h3') {
                                                return <Typography variant="body1" className={classes.titleH3} key={index}>
                                                    {row.text}
                                                </Typography>
                                            }  else if(row.tag === 'bold') {
                                                return <Typography variant="body1" className={classes.textBold} key={index}>
                                                    {row.text}
                                                </Typography>
                                            } else {
                                                if(row.text.trim().length!==0){
                                                    return <Typography variant="body1" className={classes.text} key={index}>
                                                        {row.text}
                                                    </Typography>
                                                } else {
                                                    return <div className={classes.jumpSpace} key={index}>{null}</div>
                                                }
                                            }
                                        })
                                    )
                                }

                                {
                                    infoState && infoState.video
                                        ? (<iframe width="100%"
                                                   height="100%"
                                                   title={infoState.video}
                                                   src={infoState.video}
                                                   frameBorder="0"
                                                   allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                   allowFullScreen
                                                   className={classes.videos}>
                                        </iframe>)
                                        : null
                                }
                            </div>
                        </Paper>
                        <OpinionButton/>
                    </>
                )
            }
        </ThemeProvider>

    )
}

InfoBox.propTypes = {
    country: PropTypes.string.isRequired,
    infoData: PropTypes.array.isRequired,
    isMobile: PropTypes.bool.isRequired,
}

export default InfoBox